import useFetch from '../../../hooks/useFetch';  
import { useState } from 'react';
import { buildEndpoint } from '../EndPoints';  

const useSidebarItemsService = () => {
    const { doGet } = useFetch();

    const [fetchingGetSidebarItems, setFetchingGetSidebarItems] = useState(false);
    const [fetchingSearchSidebarItems, setFetchingSearchSidebarItems] = useState(false);

    const BASE_PATH = 'sidebaritems/sidebaritems';

    const getSidebarItems = (events = {}) => {
        doGet({
            ...events,
            url: buildEndpoint(BASE_PATH),  
            setFetching: setFetchingGetSidebarItems,
        });
    };

    const searchSidebarItems = (searchTerm: string, events = {}) => {
        doGet({
            ...events,
            url: buildEndpoint(`${BASE_PATH}/search/${searchTerm}`),
            setFetching: setFetchingSearchSidebarItems,
        });
    };

    return {
        getSidebarItems,
        searchSidebarItems,
        fetchingGetSidebarItems,
        fetchingSearchSidebarItems
    };
};

export default useSidebarItemsService;
